module.exports = "/assets/images/neutral.png";